// extracted by mini-css-extract-plugin
export default {"container":"group-module__container___52d90b"};